module.exports = __webpack_public_path__ + "static/media/image_43.b806b7bc.png";